import { ErrorHandlerError } from "./ErrorHandlerError.interface"

export class B2BError extends Error implements ErrorHandlerError {
	public errorMessage: string
	public errorCode?: string
	public httpStatus: number
	static B2B_FETCH_ERROR = "There was an error fetching the B2B content"
	static B2B_UPDATE_ERROR = "There was an error updating the B2B content"

	constructor(error: ErrorHandlerError) {
		super(error.errorMessage)
		this.errorMessage = error.errorMessage
		this.httpStatus = error.httpStatus
		this.errorCode = error.errorCode
		this.name = "B2BError"
	}
}
